export class ScreenConfigRequestModel {
    PartitionKey: string = "";
    JsonData: string = "";
    constructor(partitionKey: string = "", jsonData: string = "") {
        this.PartitionKey = partitionKey;
        this.JsonData = jsonData;
    }
}